// extracted by mini-css-extract-plugin
module.exports = {"status-tag":"status-tag-71352efbcd220dac6b31d5f77d60748a"};